<!-- TODO: this component is doing already enough, it should probably be split
in multiple components -->
@let type = widgetStore.typeSg();
@let isEmbeddedWidget = isEmbeddedWidgetSg();
@let isRenderModeModal = renderModeSg() === 'modal';
@let hasOnSaveAction = widgetStore.fieldCollection.hasOnSaveActionSg();
@let hasOverflowActions = widgetStore.hasOverflowActionsSg();
@let content = widgetStore.contentSg();
@let overflowActions = widgetStore.overflowActionsSg();
@let title = widgetStore.nameSg();
@let loading = widgetStore.isLoadingSg();
@let error = widgetStore.errorSg();
@let refId = widgetStore.refIdSg();
@let hasAppliedVariableValues = hasAppliedVariableValuesSg();

<!-- TODO: !loading should be removed from here, probably? -->
@if (content && !loading) {
  @if (isEmbeddedWidget) {
    @switch (type) {
      @case (WidgetTypeEnum.Table) {
        <atn-mosaic-table />
      }
      @case (WidgetTypeEnum.Metric) {
        <atn-widget-metric
          [metric]="content"
          [overflowActions]="overflowActions"
          [refId]="refId"
        />
      }
      @case (WidgetTypeEnum.TreeEditor) {
        <atn-widget-tree-editor />
      }
      @case (WidgetTypeEnum.TreeTable) {
        <atn-widget-tree-table />
      }
    }
  } @else {
    <atn-ds-widget [title]="title">
      <ng-container actions>
        @if (hasOverflowActions) {
          <atn-widget-overflow-menu
            [actions]="overflowActions"
            [refId]="refId"
          />
        }
        @if (hasVariablesSg()) {
          <i
            class="atn-icon atn-funnel atn-blue"
            [class.atn-mosaic-widget__icon-with-info]="hasAppliedVariableValues"
            (click)="openVariablesSlideoutHandler()"
          ></i>
        }
        <!-- Show close button when in modal mode -->
        @if (isRenderModeModal) {
          <i
            class="atn-icon atn-close atn-red"
            (click)="cancelClickHandler('Header')"
          ></i>
        }
        <!-- Show save button in non-modal mode for widgets with save
          functionality -->
        @if (!isRenderModeModal && hasOnSaveAction) {
          <i
            class="atn-icon atn-save atn-blue"
            (click)="saveIconClickHandler()"
          ></i>
        }
      </ng-container>

      <!-- TODO: Widget content should probably go to in its own component when
        created -->
      <div class="atn-mosaic-widget__content">
        @switch (type) {
          @case (WidgetTypeEnum.AdaptiveCard) {
            <atn-ds-adaptive-card [payload]="content" />
          }
          @case (WidgetTypeEnum.Charts) {
            <atn-mosaic-chart />
          }
          @case (WidgetTypeEnum.ReportCard) {
            <widget-report-card />
          }
          @case (WidgetTypeEnum.ScoreCard) {
            <atn-widget-score-card />
          }
          @case (WidgetTypeEnum.Questions) {
            <atn-mosaic-survey />
          }
          @case (WidgetTypeEnum.Details) {
            <widget-details />
          }
          @case (WidgetTypeEnum.ComparisonTable) {
            <atn-widget-comparison-table />
          }
        }
      </div>

      @if (hasFooterSg()) {
        <atn-mosaic-widget-footer
          class="atn-mosaic-widget__footer"
          footer
        />
      }
    </atn-ds-widget>
  }
} @else {
  <div class="atn-mosaic-widget__empty-state-container">
    <!-- Display the close icon when the modal is open and showing an error, loading, or empty state,
     allowing the user to close the dialog. -->
    @if (isRenderModeModal) {
      <i
        class="atn-icon atn-close atn-red atn-mosaic-widget__close-icon"
        (click)="cancelClickHandler('Header')"
      ></i>
    }
    @if (error) {
      <div class="atn-mosaic-widget__empty-state-content">
        <atn-ds-empty-state
          type="error"
          title="Something went wrong"
          [description]="
            error?.toString() ?? 'Failed to load widget. No rendering returned.'
          "
          (action)="refreshButtonClickHandler()"
        />
      </div>
    } @else if (loading) {
      <div class="atn-mosaic-widget__loader">
        <atn-ds-loader type="widget" />
      </div>
    } @else {
      <div class="atn-mosaic-widget__empty-state-content">
        <atn-ds-empty-state
          type="no-data"
          title="Nothing to see here!"
          description="Try refreshing, check your source data, or contact support."
        />
      </div>
    }
  </div>
}
